import MainLayout from 'src/layouts/MainLayout';
import HomeView from 'src/views/home/HomeView';
export default function Index() {
  return (
    <MainLayout>
      <HomeView />
    </MainLayout>
  );
}
